import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export const ArticleCardLarge = ({ article }) => (
  <Link
    to={`/writings/${article.id}`}
    data-testid="article-card-item"
    className="group block"
  >
    <div className="relative overflow-hidden rounded-sm deckle aspect-[16/10]">
      <img
        src={article.image}
        alt={article.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)] via-[var(--ink)]/55 to-[var(--ink)]/10" />
      <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] bg-[var(--bg)]/90 text-[var(--text)] px-3 py-1.5 rounded-full">
        {article.category}
      </span>
      <div className="absolute bottom-0 p-6 lg:p-8">
        <h3 className="font-serif text-3xl lg:text-4xl leading-tight text-[#F9F6F0] max-w-xl drop-shadow-[0_2px_12px_rgba(0,0,0,0.7)]">
          {article.title}
        </h3>
        <p className="mt-2 font-hand text-xl text-[#F0D48A] -rotate-1 drop-shadow-[0_2px_8px_rgba(0,0,0,0.7)]">
          {article.note}
        </p>
      </div>
    </div>
    <div className="mt-4 flex items-center justify-between">
      <span className="font-sans text-sm text-[var(--text-2)]">
        {article.author} · {article.date}
      </span>
      <span className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-[var(--terracotta)]">
        <Clock className="h-3.5 w-3.5" /> {article.readTime}
      </span>
    </div>
  </Link>
);

export const ArticleCardRow = ({ article }) => (
  <Link
    to={`/writings/${article.id}`}
    data-testid="article-card-item"
    className="group flex gap-5 py-5 first:pt-0"
  >
    <div className="shrink-0 h-24 w-24 overflow-hidden rounded-sm">
      <img
        src={article.image}
        alt={article.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
    </div>
    <div className="min-w-0">
      <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-[var(--gold)]">
        {article.category}
      </span>
      <h4 className="mt-1 font-serif text-xl leading-snug text-[var(--text)] group-hover:text-[var(--terracotta)] transition-colors duration-300">
        {article.title}
      </h4>
      <span className="mt-1 block font-sans text-xs text-[var(--text-2)]">
        {article.date} · {article.readTime}
      </span>
    </div>
  </Link>
);

export const ArticleCardGrid = ({ article }) => (
  <Link
    to={`/writings/${article.id}`}
    data-testid="article-card-item"
    className="group flex flex-col"
  >
    <div className="relative overflow-hidden rounded-sm deckle aspect-[4/3]">
      <img
        src={article.image}
        alt={article.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <span className="absolute top-3 left-3 font-mono text-[9px] uppercase tracking-[0.2em] bg-[var(--bg)]/90 text-[var(--text)] px-2.5 py-1 rounded-full">
        {article.category}
      </span>
    </div>
    <h3 className="mt-4 font-serif text-2xl leading-tight text-[var(--text)] group-hover:text-[var(--terracotta)] transition-colors duration-300">
      {article.title}
    </h3>
    <p className="mt-2 font-sans text-sm text-[var(--text-2)] leading-relaxed line-clamp-2">
      {article.excerpt}
    </p>
    <span className="mt-3 font-sans text-xs text-[var(--text-2)]">
      {article.author} · {article.date} · {article.readTime}
    </span>
  </Link>
);
